import React from 'react'
import { IconButtons } from '../../ui-components'
import LeadsCreateForm from '../../generalComponents/LeadsCreateForm';
import Card from "../Card";
import { Button } from "@aws-amplify/ui-react";

function CreateLeadForm({onToggleTab, user, userName}) {
  
  return (
    <div className="mt-16">
      <Card
      textTitle="Crear Lead"
      classNameBody="py-8"
      elementBody={
        <div className="flex flex-col gap-1 px-6">
          <div className="flex justify-end"> 
            <Button variation="primary" size="small" onClick={() =>onToggleTab(1)}><IconButtons variant="back"/> Atrás</Button>
          </div>
            <LeadsCreateForm onToggleTab={onToggleTab} user={user} userName={userName}/>
        </div>
      }
    />
    </div>
  )
}

export default CreateLeadForm